import styled from 'styled-components';

import { ctrlBase, fieldContainer, fieldLabel, fieldMessage } from '../base';

export const inputContainer = styled.div`
  ${fieldContainer}
`;

export const input = styled.input<{ $arrow?: boolean }>`
  ${ctrlBase}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: ${({ $arrow }) => ($arrow ? 'auto' : 'none')};
    margin: 0;
  }
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const img = styled.img`
  &.icon {
    position: absolute;
    right: var(--s3);
    bottom: 0;
    top: 0;
    margin: auto;
  }
`;

export const InputBox = styled.div`
  position: relative;
`;

export const Icon = styled.div`
  position: absolute;
  right: var(--s2);
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  color: var(--text-faint);
  line-height: 0;
`;
